<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
    no-click-animation
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile class="company elevation-0" style="background-color: #E7E7E7">
      <v-toolbar flat dark color="primary" max-height="64">
        <v-spacer></v-spacer>
        <v-toolbar-title
          style="font-size: 30px; font-weight: 300; letter-spacing: 0"
          >{{ company.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="dialog = false">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-row class="align-stretch">
          <v-col cols="12" sm="6" md="4" lg="3" class="pa-1">
            <company-info-card
              :loading="!info"
              :action-button="true"
              :action-button-title="mess.dialog_create_lead_open_button"
              :title="mess.dialog_company_info_card_info_title"
              @action-button-click="
                $emit('open-create-lead-dialog', {
                  id: company.id,
                  name: company.name
                })
              "
            >
              <template v-if="info">
                <v-row class="overflow-y-auto">
                  <v-col cols="12">
                    <v-row
                      v-for="(item, i) in info"
                      :key="i"
                      class="pl-6 pr-4 pt-4"
                    >
                      <v-col
                        class="pa-0 pl-1"
                        cols="5"
                        style="color: #1a1a1a; font-size: 12px; text-transform: uppercase; font-weight: 500;"
                        >{{ item.title
                        }}<tooltip
                          v-if="item.info"
                          :info="item.info"
                          :tooltip-color="'#676766'"
                        ></tooltip
                      ></v-col>
                      <v-col
                        class="pa-0"
                        cols="7"
                        style="line-height: 1.1; font-weight: 500; font-size: 14px; letter-spacing: normal"
                        :style="{ color: siteColors.primary }"
                        ><a
                          v-if="item.type === 'link' && item.value !== '-'"
                          :href="
                            checkHttpSubString(item.value)
                              ? item.value
                              : `http://${item.value}`
                          "
                          target="_blank"
                          style="text-decoration: none"
                          >{{ item.value }}</a
                        ><a
                          v-else-if="
                            item.type === 'phone' && item.value !== '-'
                          "
                          :href="`tel:${item.value}`"
                          style="text-decoration: none"
                          >{{ item.value }}</a
                        ><span v-else>{{ item.value }}</span></v-col
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </template>
            </company-info-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pa-1">
            <company-info-card
              :loading="!mve"
              :go-to-section-button="true"
              :section-link="'/personal/my_market/'"
              :title="mess.dialog_company_info_card_mve_title"
            >
              <v-row v-if="mve" class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-carousel
                    hide-delimiters
                    class="chart-slider"
                    show-arrows-on-hover
                    height="100%"
                    width="100%"
                  >
                    <v-carousel-item v-for="(item, i) in mve" :key="i">
                      <p class="card-label text-center mb-0">
                        {{ item.title }}
                      </p>
                      <v-row
                        class="chart-wrapper justify-center overflow-y-auto ma-0 pa-0"
                        style="height: 34vh; width: 100%"
                      >
                        <v-col
                          v-if="!isEmpty(mve)"
                          cols="12"
                          class="pa-0 pt-2 pb-2"
                          style="margin-top: -75px"
                        >
                          <doughnut-chart
                            :chart-data="item"
                            :options="
                              createDoughnutChartOptions(item.units || '')
                            "
                          ></doughnut-chart>
                        </v-col>
                        <v-col
                          cols="12"
                          class="pa-0"
                          style="position: relative"
                          :style="{
                            'margin-top': !isEmpty(item) ? '-70px' : 0
                          }"
                        >
                          <v-data-table
                            :headers="
                              item.quantity
                                ? [
                                    {
                                      text: mess['table_mve_header_name'],
                                      value: 'name'
                                    },
                                    {
                                      text: mess['table_mve_header_quantity'],
                                      value: 'quantity'
                                    },
                                    {
                                      text: mess['table_mve_header_mve'],
                                      value: 'value'
                                    }
                                  ]
                                : [
                                    {
                                      text: mess['table_mve_header_name'],
                                      value: 'name'
                                    },
                                    {
                                      text: mess['table_mve_header_mve'],
                                      value: 'value'
                                    }
                                  ]
                            "
                            :items="mveTableData[i]"
                            hide-default-footer
                            disable-pagination
                            light
                            class="company-info-table"
                          ></v-data-table>
                        </v-col>
                      </v-row>
                    </v-carousel-item>
                  </v-carousel>
                </v-col>
              </v-row>
            </company-info-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pa-1">
            <company-info-card
              :loading="!ib"
              :go-to-section-button="true"
              :section-link="
                '/personal/my_customers/installations_maintenance/'
              "
              :title="mess.dialog_company_info_card_ib_title"
            >
              <v-row
                v-if="ib"
                class="chart-wrapper justify-center overflow-y-auto ma-0 pa-0"
              >
                <v-col
                  v-if="!isEmpty(ib)"
                  cols="12"
                  class="pa-0 pt-2 pb-2"
                  style="margin-top: -75px"
                >
                  <doughnut-chart
                    :chart-data="ib"
                    :options="createDoughnutChartOptions(ib.units || '')"
                  ></doughnut-chart>
                </v-col>
                <v-col
                  cols="12"
                  class="pa-0"
                  style="position: relative"
                  :style="{ 'margin-top': !isEmpty(ib) ? '-70px' : 0 }"
                >
                  <v-data-table
                    :headers="[
                      { text: 'Наименование', value: 'name' },
                      { text: 'Колличество', value: 'value' }
                    ]"
                    :items="ibTableData"
                    hide-default-footer
                    disable-pagination
                    class="company-info-table"
                  ></v-data-table>
                </v-col>
              </v-row>
            </company-info-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pa-1">
            <company-info-card
              :loading="!cp"
              :go-to-section-button="true"
              :section-link="
                '/personal/my_customers/installations_maintenance/'
              "
              :title="mess.dialog_company_info_card_cp_title"
            >
              <template v-if="cp">
                <company-info-total :items="cp"></company-info-total>
              </template>
            </company-info-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pa-1">
            <company-info-card
              :loading="!orders"
              :is-toggle-buttons="true"
              :view-type-prop="ordersViewType"
              v-model="ordersViewType"
              :go-to-section-button="true"
              :section-link="'/personal/my_customers/order_history/'"
              :title="mess.dialog_company_info_card_orders_title"
            >
              <v-row v-if="orders && ordersViewType === 'list'">
                <v-col style="overflow-y: scroll; height: 33vh" class="pt-0">
                  <v-data-table
                    :headers="orders.headers"
                    :items="orders.items"
                    hide-default-footer
                    disable-pagination
                    class="company-info-table"
                  >
                    <template v-slot:item.href="{ item }">
                      <v-btn
                        tag="a"
                        :href="item.href"
                        target="_blank"
                        x-small
                        height="24"
                        outlined
                        color="primary"
                        style="min-height: 24px !important;"
                        >{{ mess.dialog_base_button_go_to }}</v-btn
                      >
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div class="order-status--company-card">
                        <span>{{ item.status }}</span>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <template v-if="orders && ordersViewType === 'total'">
                <company-info-total :items="orders.total"></company-info-total>
              </template>
            </company-info-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pa-1">
            <company-info-card
              :loading="!wishlists"
              :action-button="true"
              :action-button-title="
                mess.dialog_base_button_show_create_wishlist
              "
              :go-to-section-button="true"
              :section-link="'/personal/my_customers/wishlists/'"
              :title="mess.dialog_company_info_card_wishlists_title"
              @action-button-click="
                $emit('open-wishlist-adding-dialog', {
                  id: company.id,
                  name: company.name
                })
              "
            >
              <v-row v-if="wishlists">
                <v-col style="overflow-y: scroll; height: 31vh" class="pt-0">
                  <v-data-table
                    :headers="wishlists.headers"
                    :items="wishlists.items"
                    hide-default-footer
                    class="company-info-table"
                  ></v-data-table>
                </v-col>
              </v-row>
            </company-info-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="4" class="pa-1">
            <company-info-card
              :loading="!requests"
              :action-button="true"
              :is-toggle-buttons="true"
              :view-type-prop="requestsViewType"
              :action-button-title="mess.dialog_base_button_show_create_request"
              v-model="requestsViewType"
              :go-to-section-button="true"
              :section-link="'/personal/requests/'"
              :title="mess.dialog_company_info_card_requests_title"
              @action-button-click="
                $emit('open-request-adding-dialog', {
                  id: company.id,
                  name: company.name
                })
              "
            >
              <template v-if="requests && requestsViewType === 'list'">
                <v-row>
                  <v-col style="overflow-y: scroll; height: 30vh" class="pt-0">
                    <v-data-table
                      :headers="requests.headers"
                      :items="requests.items"
                      hide-default-footer
                      disable-pagination
                      class="company-info-table"
                    >
                      <template v-slot:item.status="{ item }">
                        <b
                          :style="{
                            color: statusCodes[item.status_code]
                          }"
                          >{{ item.status }}</b
                        >
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </template>
              <template v-if="requests && requestsViewType === 'total'">
                <company-info-total
                  :items="requests.total"
                ></company-info-total>
              </template>
            </company-info-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
// Libs
import isEmpty from "lodash/isEmpty";

// Components
import DoughnutChart from "@/components/DoughnutChart";
import CompanyInfoCard from "@/components/CompanyInfoCard";
import CompanyInfoTotal from "@/components/CompanyInfoTotal";
import Tooltip from "@/components/Tooltip";

// Models
import createDoughnutChartData from "@/models/createDoughnutChartData";
import createDoughnutChartOptions from "@/models/createDoughnutChartOptions";

export default {
  name: "CompanyInfoDialog",
  components: {
    Tooltip,
    CompanyInfoTotal,
    CompanyInfoCard,
    DoughnutChart
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: () => {}
    },
    detailedCompanyData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      itemsList: [],
      ordersViewType: "total",
      requestsViewType: "total",
      stubImage: "/assets/img/stub-gear.png",
      statusCodes: {
        "0": "#ffca41",
        "1": "#41cc24",
        "2": "#ea5329"
      }
    };
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
      !!val || setTimeout(() => this.$emit("close-dialog"), 200);
    }
  },
  computed: {
    info() {
      return this.detailedCompanyData.info;
    },
    mve() {
      if (this.detailedCompanyData.mve) {
        return this.detailedCompanyData.mve.map(item =>
          createDoughnutChartData(item)
        );
      }
      return null;
    },
    ib() {
      if (this.detailedCompanyData.ib) {
        return createDoughnutChartData(this.detailedCompanyData.ib);
      }
      return null;
    },
    mveTableData() {
      if (this.detailedCompanyData.mve) {
        return this.detailedCompanyData.mve.map(item => {
          return this.createChartTableData(item);
        });
      }
      return null;
    },
    ibTableData() {
      if (this.detailedCompanyData.ib) {
        return this.createChartTableData(this.detailedCompanyData.ib);
      }
      return null;
    },
    cp() {
      return this.detailedCompanyData.cp;
    },
    orders() {
      return this.detailedCompanyData.orders;
    },
    wishlists() {
      return this.detailedCompanyData.wishlists;
    },
    requests() {
      return this.detailedCompanyData.requests;
    },
    toggleButtons() {
      return [
        {
          name: this.mess.dialog_company_info_toggle_button_total,
          type: "total"
        },
        {
          name: this.mess.dialog_company_info_toggle_button_list,
          type: "list"
        }
      ];
    }
  },
  methods: {
    checkHttpSubString(url) {
      const httpPattern = /^http[s]*:\/\/[\w]+/i;
      return !!url.match(httpPattern);
    },
    createChartTableData(data) {
      return data.labels.map((label, i) => ({
        name: label,
        value: data.datasets[0].data[i],
        quantity: data.quantity ? data.quantity[i] : undefined
      }));
    }
  },
  mounted() {
    this.isEmpty = isEmpty;
    this.createDoughnutChartOptions = createDoughnutChartOptions;
  }
};
</script>

<style lang="scss">
.company .container {
  background-color: #e7e7e7;
}

.company-info-table.v-data-table {
  thead tr {
    vertical-align: baseline;
    line-height: 1;
  }

  th {
    padding: 8px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.4;
    color: #9c9c9c;
  }

  td {
    height: 30px !important;
    font-size: 12px !important;
    padding: 8px 16px;
  }

  .v-chip__content {
    margin: 0 auto;
  }
}

.company .v-data-table table td {
  font-weight: 500;
  line-height: 1.1;

  @media (max-width: 1536px) {
    font-size: 13px;
  }
}

.company-card .chart-wrapper {
  &::-webkit-scrollbar {
    width: 4px;
    background: rgba(0, 0, 0, 0.12);
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    background: rgba(0, 0, 0, 0.12);
  }
}

.chart-slider {
  .v-window__prev {
    margin-left: 5px;

    button {
      min-height: 36px;
    }
  }

  .v-window__next {
    margin-right: 5px;

    button {
      min-height: 36px;
    }
  }
}

.card-label {
  position: absolute;
  padding: 4px 8px;
  border-bottom-right-radius: 6px;
  line-height: 1.6;
  font-weight: 500;
  font-size: 14px;
  background: #e0e0e0;
}

.order-status--company-card {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 4px;
  font-weight: 500;
  font-size: 10px;
  color: var(--v-primary-base);
  background-color: var(--v-light-base);
  border-radius: 4px;
  min-height: 24px;
  white-space: nowrap;
}
</style>
